import { FC, HTMLAttributes } from 'react'
import { useTravelDurationMessage } from '@/root/shared-hooks'
import { BottomArrowIcon, LockIconGray, VesselIcon } from '@/root/ui/shared'
import { VoyageInfo } from '@/root/shared-types'
import cn from 'classnames'

interface TripInfoCardProps extends HTMLAttributes<HTMLDivElement> {
  routeInfo: VoyageInfo
}

export const TripInfoCard: FC<TripInfoCardProps> = ({ routeInfo }) => {
  const { departurePort, arrivalPort, shipName, duration } = routeInfo
  const travelDurationMessage = useTravelDurationMessage(duration)

  return (
    <div
      data-testid="trip-info-locked"
      className={cn(
        'border-base-normal-lighter bg-neutral-lightest text-base-normal-light text-large flex w-full cursor-not-allowed flex-col justify-between rounded-xl border p-4 leading-9 font-bold',
        {
          'min-h-48': !departurePort || arrivalPort,
          'min-h-32': departurePort && !arrivalPort,
        }
      )}
    >
      <div className="flex items-center justify-between">
        <p>{departurePort}</p>
        <LockIconGray className="shrink-0" />
      </div>
      <div className="flex items-center">
        {Boolean(arrivalPort) && <BottomArrowIcon />}
        <p className="text-base-normal-lighter xxs:text-base ms-3 text-sm whitespace-pre-line">
          {travelDurationMessage}
        </p>
      </div>
      <p>{arrivalPort}</p>
      <div className="flex items-center">
        <VesselIcon color="base-normal-lighter" />
        <p className="text-base-normal-lighter ms-3 text-xs uppercase">{shipName}</p>
      </div>
    </div>
  )
}
